/* <video-element class="video-wrapper relative">
  <div class="video">
    {{ section.settings.video | video_tag: controls: section.settings.video_controls, autoplay: section.settings.video_autoplay, muted: muted, loop: section.settings.video_loop }}
  </div>
  {%- if muted and video_controls == false -%}
    <button class="video-mute-button button button--sm absolute right-4 bottom-4 z-10" data-video-mute-button aria-label="Toggle video sound">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon audio-on hidden size-6" data-icon-audio-on>
        <path stroke-linecap="round" stroke-linejoin="round" fill="none"  d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z" stroke="currentColor" />
      </svg>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon audio-off size-6" data-icon-audio-off>
        <path stroke-linecap="round" stroke-linejoin="round" fill="none" d="M17.25 9.75 19.5 12m0 0 2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6 4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z" stroke="currentColor" />
      </svg>
    </button>
  {%- endif -%}
</video-element> */

class VideoElement extends HTMLElement {
  constructor() {
    super();

    this.videoElement = this.querySelector('video');
    this.videoMuteButton = this.querySelector('[data-video-mute-button]');
    this.videoMuteButton.addEventListener('click', () => {
      if (this.videoElement.muted) {
        this.unmuteVideo();
      }
      else {
        this.muteVideo();
      }
    });
  }

  muteVideo() {
    this.videoElement.muted = true;
    this.videoMuteButton.querySelector('[data-icon-audio-on]').classList.add('hidden');
    this.videoMuteButton.querySelector('[data-icon-audio-off]').classList.remove('hidden');
  }

  unmuteVideo() {
    this.videoElement.muted = false;
    this.videoMuteButton.querySelector('[data-icon-audio-on]').classList.remove('hidden');
    this.videoMuteButton.querySelector('[data-icon-audio-off]').classList.add('hidden');
  }
}

if (!customElements.get('video-element')) {
  customElements.define('video-element', VideoElement);
}